import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";

const DEFAULTS = {
  slogan: "Forget Your Stripes. Earn Your Spots.",
  welcome_popup_title: "Welcome to Spotter, Let's earn your spots.",
  welcome_popup_body: "",
  about_owner_title: "Meet The Leopard King",
  about_owner_body: "",
  reporting_policy: "",
  landing_headline: "A social home with real people, real moderation, and a whole lot of nostalgia.",
  login_updates: "🐆 Welcome to Spotter! We're brand new — claim your spot early and become a Top Spotter. New features drop weekly. Be yourself, respect others, keep it real.",
  community_rule: "🐆 Spotter Community Rule 🐆\nSpotter is an open space where you can be yourself freely, as long as you are not disrespecting, harassing, bullying, or harming others.\nWe only have one major rule when it comes to profiles:\nYour profile picture must be a real photo of yourself, and you must upload at least one additional photo of yourself to help verify that you are not a catfish.\nYou are welcome to upload other pictures on your statuses and albums but every member must have at least two photos of themselves on their profile. This is to help protect the safety of all Spotter members and keep our community as real and trustworthy as possible.\nIf you are suspected or reported as a catfish, your profile may be investigated. If it is confirmed that you are assuming someone else's identity, impersonating someone, or using fake photos, you will be banned from Spotter.\nBe yourself. Respect others. Keep it real. 🐾\nForget your stripes. Earn your spots truthfully. 🐆\n-TheLeopardKing",
  theme: { maroon: "#520202", gold: "#E19C00", cream: "#FFFFED" },
  backgrounds: [],
  background_disclaimer: "To limit copyright infringement, photos will be added periodically as Spotter obtains rights to them and/or obtains free stock photos.",
  footer_text: "© 2026 Spotter. All rights reserved.",
  logo_url: "https://customer-assets.emergentagent.com/job_spotter-network/artifacts/gp7xudj1_ChatGPT_Image_Jul_12__2026__11_18_04_PM-removebg-preview.png",
  notification_sound_url: "https://customer-assets.emergentagent.com/job_spotter-network/artifacts/le8mtyx3_LEOPARD%20SOUND%20EFFECTS%20-%20Leopard%20Sounds%20%20Maktubytv-%5BAudioTrimmer.com%5D.mp3",
  spotlight_den_pdf_url: "/api/files/spotter/uploads/spotlight/dc046aa1-1c7c-4367-bac4-189c583c8bd5.pdf",
  spotlight_den_images: [],
  premium_popup_enabled: true,
  premium_popup_title: "🐆 Coming Soon: Spotter Premium Memberships",
  premium_popup_body: "",
  donation_banner_enabled: true,
  donation_banner_text: "",
  donation_paypal_url: "",
  donation_venmo_url: "",
  pay_paypal_me: "",
  pay_venmo: "",
  subscription_intro: "",
  subscription_tiers: [],
};

const SiteContentContext = createContext(null);

function hexToRgbChannels(hex) {
  if (!hex) return null;
  const m = hex.replace("#", "").match(/^([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i);
  if (!m) return null;
  return `${parseInt(m[1], 16)} ${parseInt(m[2], 16)} ${parseInt(m[3], 16)}`;
}

function applyTheme(theme) {
  const root = document.documentElement;
  const map = { maroon: "--maroon", gold: "--gold", cream: "--cream" };
  Object.entries(map).forEach(([k, cssVar]) => {
    const hex = theme?.[k];
    if (!hex) return;
    root.style.setProperty(cssVar, hex);
    const ch = hexToRgbChannels(hex);
    if (ch) root.style.setProperty(`${cssVar}-rgb`, ch);
  });
}

export function SiteContentProvider({ children }) {
  const [content, setContent] = useState(DEFAULTS);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/site-content");
      setContent({ ...DEFAULTS, ...data });
      if (data.theme) applyTheme(data.theme);
    } catch (e) {}
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <SiteContentContext.Provider value={{ content, refresh, setContent }}>
      {children}
    </SiteContentContext.Provider>
  );
}

export function useSiteContent() {
  const ctx = useContext(SiteContentContext);
  return ctx || { content: DEFAULTS, refresh: () => {}, setContent: () => {} };
}
